export const MEDIA_TYPE_IMAGE = 'MEDIA_TYPE_IMAGE';
export const MEDIA_TYPE_VIDEO = 'MEDIA_TYPE_VIDEO';
export const TAG_MEDIA_MAX_SIZE_SMALL = 250;
export const TAG_MEDIA_MAX_SIZE = 350;
export const TAG_VIDEO_PROGRESS_STEPS = [20, 40, 60, 80, 100];

export default {
  MEDIA_TYPE_IMAGE,
  MEDIA_TYPE_VIDEO,
  TAG_MEDIA_MAX_SIZE_SMALL,
  TAG_MEDIA_MAX_SIZE,
  TAG_VIDEO_PROGRESS_STEPS,
};
